var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors && _vm.errors.length)?_c('div',{staticClass:"alert alert-danger mt-3"},[_c('h4',{staticClass:"mb-2 mt-1"},[_vm._v("\n    "+_vm._s(_vm.$tc(
        _vm.$translate.ErrorsWereFoundInTheFollowingLinesFixThemAndStartImportingAgain
      ))+"\n  ")]),_vm._l((_vm.errors),function(err,i){return _c('div',{key:i},[_vm._v(_vm._s(i + 1)+". "+_vm._s(err))])})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }